import styled from "styled-components";
import { colors } from "../../../theme";

const Button = styled.a.withConfig({
  displayName: "Button",
})`
  height: 50px;
  padding: 0px 30px;
  background-color: ${colors.white};
  font-family: "Red Hat Display", sans-serif;
  outline: none;
  margin: 0;
  border-left: 0;
  border-top: 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.2px;
  color: rgb(13, 13, 13);
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;

  &:active {
    transform: translate3d(1px, 1px, 0px);
    border: 0;
  }
`;

export default Button;
